import { Box, Typography } from "@mui/material";
import CustomLabel from "./CustomLabel";
import { FC } from "react";

interface CustomCellProps {
  label: string;
  value: string;
}
const CustomCell: FC<CustomCellProps> = ({ label, value }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CustomLabel label={label} />
      <Typography>{value}</Typography>
    </Box>
  );
};

export default CustomCell;
